import { Modal, Spin } from 'antd';
import React, { useState } from 'react';
import { Check, CloseIcon, PlaidLogo, RealBricksLogo } from '../../assets/icons';
import '../../pages/Signup/LinkBank/LinkBank.scss';
import LinkBankAccount from './LinkBankAccount';

const BankAccountModal = (props) => {
  const {
    bankModalOpen,
    setBankModalOpen,
    onSuccess,
    onClose = () => {},
    linkTokenUnverified,
    bankVerificationStatus,
    handleUpdateBanksList = () => {},
    shouldUpdateList = false,
  } = props;
  const [loading, setLoading] = useState(false);
  return (
        <Modal
          open={bankModalOpen}
          footer={false}
          closeIcon={<CloseIcon color='#1A1519' verticalAlign='-7px' marginRight='5px' />}
          onCancel={() => {
            setLoading(false);
            setBankModalOpen(false);
            onClose();
          }}
          width={524}
          centered
        >
          <Spin spinning={loading}>
            <div className='connectbank'>
              <div className='connectbank__logos'>
                <RealBricksLogo></RealBricksLogo>
                <PlaidLogo></PlaidLogo>
              </div>
              <p className='connectbank__title'>
                Realbricks uses <span className='fw-700'>Plaid</span> to link your bank
              </p>
              <div className='connectbank__list'>
                <div className='connectbank__item'>
                  <Check marginRight='10px' />
                  <div>
                    <p className='fw-500'>Connect effortlessly</p>
                    <p>Plaid lets you securely connect your financial accounts in seconds</p>
                  </div>
                </div>
                <div className='connectbank__item'>
                  <Check marginRight='10px' />
                  <div>
                    <p className='fw-500'>Your data belongs to you</p>
                    <p>Plaid doesn’t sell personal info, and will only use it with your permission</p>
                  </div>
                </div>
              </div>
              <LinkBankAccount
                buttonName='Continue'
                className='w-100 ant-btn ant-btn-primary ant-btn-primary--alt bank-btn'
                bankModalOpen={bankModalOpen}
                setBankModalOpen={setBankModalOpen}
                onSuccess={(data) => {
                  // setBankModalOpen(false);
                  onSuccess(data);
                  setLoading(false);
                }}
                startLoading={() => setLoading(true)}
                stopLoading={() => setLoading(false)}
                onFail={() => {
                  setLoading(false);
                  setBankModalOpen(false);
                }}
                handleUpdateBanksList={handleUpdateBanksList}
                onClose={onClose}
                linkTokenUnverified={linkTokenUnverified}
                bankVerificationStatus={bankVerificationStatus}
                shouldUpdateList={shouldUpdateList}
              />
            </div>
          </Spin>
        </Modal>
  );
};

export default BankAccountModal;
